module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n\n.mat-cell {\n  position: relative; }\n\n.mat-column-status {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 50px;\n          flex: 0 1 50px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/customer/components/group-tile.component.scss
// module id = ./src/app/customer/components/group-tile.component.scss
// module chunks = main